<template>
  <router-view></router-view>
</template>

<style src="./app.css" />
<script lang="ts" setup>
import {RouterView} from 'vue-router'
</script>